import React from "react";

import { CustomModal } from "components/base/BaseModal";
import { ButtonContent, ButtonPrimary } from "components/base/BaseButton";

const rsuiteButtonColors = new Set([
    "red",
    "orange",
    "yellow",
    "green",
    "cyan",
    "blue",
    "violet"
]);

export const Modal = ({
    show,
    onClose,
    onSuccess,
    checkBefore,
    children,
    title,
    width,
    size,
    disabled,
    maxHeight, // px
    customMarginTop, // %
    footer = false,
    successText = "Ok",
    cancelText = "Cancel",
    extraDisabled = false,
    extraDialogClassName = "",

    extraButtons = null,

    successButtonColor = "#20BA88",
    onEntered
    = () => {

    }
}) => {

    const style = {};
    width && (style.width = width);
    const successButtonProps = rsuiteButtonColors.has(successButtonColor)
        ? { color: successButtonColor }
        : {
            style: {
                backgroundColor: successButtonColor,
                borderColor: successButtonColor
            }
        };
    const customFooter = footer
        ? () => (
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-around"
                }}
            >
                <ButtonPrimary
                    {...successButtonProps}
                    loading={disabled}
                    disabled={extraDisabled}
                    onClick={() => {
                        if (checkBefore && !checkBefore()) return false;
                        onSuccess()
                    }}
                >
                    {successText}
                </ButtonPrimary>
                <ButtonContent
                    onClick={onClose}
                    disabled={disabled}
                >
                    {cancelText}
                </ButtonContent>
                {extraButtons}
            </div>
        )
        : null;

    return (
        <CustomModal
            show={show}
            onClose={onClose}
            style={style}
            size={size}
            title={title}
            onEntered={onEntered}
            customMarginTop={customMarginTop}
            maxHeight={maxHeight}
            extraDialogClassName={extraDialogClassName}
            showFooter={footer}
            customFooter={customFooter}
        >
            {children}
        </CustomModal>
    );
};

export default Modal;
